import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../environments/environment';
import {Hold} from '../models/hold';

const API = environment.API;

@Injectable({
  providedIn: 'root',
})
export class HoldService {

  constructor(private http: HttpClient) {
  }

  createHold(placeId: string, begin?: string, end?: string) {
    const body = {placeId, begin, end};
    return this.http.post<Hold>(`${API}/api/holds`, body);
  }

  createFutureHold(placeId: string, begin: string, end: string | null = null) {
    const body = {placeId, begin, end};
    return this.http.post<Hold>(`${API}/api/holds/future`, body);
  }

  createVisitHold(placeId: string, visitId: string, email: string, firstName: string, lastName: string) {
    const body = {placeId, visitId, email, firstName, lastName};
    return this.http.post<Hold>(`${API}/api/holds/visit`, body);
  }

  getById(id: string) {
    return this.http.get<Hold>(`${API}/api/holds/${id}`);
  }

  findHolds(limit = 1000, skip = 0) {
    const params = {limit, skip};
    return this.http.get<Hold[]>(`${API}/api/holds`, {params});
  }

  findActiveByUser(limit = 1000, skip = 0) {
    const params = {limit, skip};
    return this.http.get<Hold[]>(`${API}/api/holds/user/active`, {params});
  }

  findActiveByPlaceId(placeId: string, limit = 1000, skip = 0) {
    const params = {limit, skip};
    return this.http.get<Hold[]>(`${API}/api/holds/place/${placeId}/active`, {params});
  }

  findFutureHolds(limit = 1000, skip = 0) {
    const params = {limit, skip};
    return this.http.get<Hold[]>(`${API}/api/holds/future`, {params});
  }

  findFutureHoldsByUser(limit = 1000, skip = 0) {
    const params = {limit, skip};
    return this.http.get<Hold[]>(`${API}/api/holds/user/future`, {params});
  }

  findFutureHoldsByPlaceId(placeId: string, limit = 1000, skip = 0) {
    const params = {limit, skip};
    return this.http.get<Hold[]>(`${API}/api/holds/place/${placeId}/future`, {params});
  }

  updateSeat(holdId: string, seatCount: number, guests: any[]) {
    const body = {seatCount, guests};
    return this.http.put(`${API}/api/holds/${holdId}/seats`, body);
  }

  updateChange(holdId: string, placeId: string, begin: string, end: string) {
    const body = {placeId, begin, end};
    return this.http.put(`${API}/api/holds/${holdId}/change`, body);
  }

  arrive(holdId: string) {
    return this.http.put(`${API}/api/holds/${holdId}/arrive`, {});
  }

  arriveGuest(holdId: string) {
    return this.http.put(`${API}/api/holds/${holdId}/arrive/guest`, {});
  }

  end(holdId: string) {
    return this.http.put(`${API}/api/holds/${holdId}/end`, {});
  }

  cancelAndNotify(holdId: string) {
    return this.http.put(`${API}/api/holds/${holdId}/cancelnotify`, {});
  }

  deactivate(holdId: string) {
    return this.http.put(`${API}/api/holds/${holdId}/deactivate`, {});
  }
}
